import { Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { noop } from 'lodash-es';
import { ReactNode } from 'react';

interface SkuStockStatusProps {
  skuInfo: Conversation.ProductSKUInfo;
  isERP: boolean;
}

export const SkuStockStatus = (props: SkuStockStatusProps) => {
  const { skuInfo, isERP } = props;
  const { skuStockStatus, erpStock, platformOutOfStock, estimatedAvailableTime } = skuInfo;
  const { t } = useTranslate();

  if (skuStockStatus === 'InStock') {
    return <>{isERP ? t('outofstock_status_2') : t('stock.exist')}</>;
  }
  if (skuStockStatus === 'OutOfStock') {
    return <>{isERP ? t('平台缺货') : t('ViewDashboard.LAZADA.Out of stock')}</>;
  }
  if (skuStockStatus === 'ErpInStock') {
    if (!erpStock?.length) {
      return (
        <div>
          <div>{t('ERP有货')}</div>
          {platformOutOfStock && (
            <div style={{ color: 'var(--ant-error-color)' }}>{t('平台缺货')}</div>
          )}
        </div>
      );
    }
    return (
      <div>
        <div>
          {t('ERP有货')}
          <Tooltip
            title={erpStock.reduce<ReactNode[]>((res, { warehouseName, warehouseInventory }) => {
              if (res.length > 0) {
                res.push(<br />);
              }
              res.push(`${warehouseName}: ${warehouseInventory}`);
              return res;
            }, [])}
          >
            <InfoCircleOutlined style={{ marginLeft: '4px' }} onClick={noop} />
          </Tooltip>
        </div>
        {platformOutOfStock && (
          <div style={{ color: 'var(--ant-error-color)' }}>{t('平台缺货')}</div>
        )}
      </div>
    );
  }
  if (skuStockStatus === 'ErpOutOfStock') {
    return <>{t('ERP缺货')}</>;
  }
  if (skuStockStatus === 'MarkedOutOfStock') {
    return (
      <div>
        <span>{t('outofstock_status_1')}</span>
        {estimatedAvailableTime && (
          <Tooltip title={`${t('outofstock_youhuoriqi')}：${estimatedAvailableTime}`}>
            <InfoCircleOutlined className="ml-[4px]" />
          </Tooltip>
        )}
      </div>
    );
  }

  return null;
};

export const SkuStockStatusTitle = (props: { isERP: boolean }) => {
  const { isERP } = props;
  const { t } = useTranslate();
  return (
    <div className="items-center flex">
      <span>{t('outofstock_stock_status')}</span>
      <Tooltip
        title={
          <div>
            <div>{isERP ? t('outofstock_status_tip1_1') : t('outofstock_status_tip1')}</div>
            {isERP && <div>{t('outofstock_status_tip1_2')}</div>}
            <div>{t('outofstock_status_tip2_copy')}</div>
          </div>
        }
      >
        <QuestionCircleOutlined className="ml-[4px]" />
      </Tooltip>
    </div>
  );
};
